export default "__VITE_ASSET__k4MvRhJe__"